import React, {
  useState,
  useEffect,
  FunctionComponent,
  useCallback,
  useRef,
} from 'react'
// @ts-ignore
import io from 'socket.io-client'
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux'
import { isEmpty } from 'lodash'
import { useTranslation } from 'react-i18next'
import ReactLoading from 'react-loading'

import CachedIcon from 'mdi-react/CachedIcon'
import { getAllCuratorGenres } from 'Redux/actions/genresActions'
import { getAllLanguages } from 'Redux/actions/languagesActions'
import { getAllMoods } from 'Redux/actions/moodsActions'
import ConnectToSpotifyModal from 'Containers/ui/ConnectToSpotifyModal'
import { APP } from 'Configs/App'
import { WhiteGreyBtn } from 'Stories/Button/Button.stories'
import { PlaylistsProps } from 'Shared/types/common'
import { colors } from 'Styled/variables'
import {
  Mood,
  NewPlaylist,
  Genre,
  Language,
  TrackGenre,
  Playlist,
  ErrorWithFlag,
} from '../../../../Types'
import PlaylistEditModal from '../PlaylistEditModal'
import PlayListCard from '../PlayListCard'
import AddPlaylistModal from '../AddPlaylistModal'
import FindPlaylistMobile from '../FindPlaylistMobile'
import { PlaylistComponentProps } from '../../PlaylistProps'

import * as S from './styles'
import { getCuratorSpotifyId } from '../../../../Redux/selectors/auth'

const PlayList: FunctionComponent<PlaylistComponentProps> = ({
  playlists,
  changePlaylistInformation,
  spotifyAccessToken,
  allGenres,
  getCuratorRank,
  checkPlaylist,
  getAutoselectedSpotifyPlaylistGenres,
  userEmail,
  updateStatePlaylists,
  languages,
  getPlaylists,
  setPageTitle,
  recentlyAddedPlaylist,
  setRecentlyAddedPlaylist,
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const allMoods: Array<Mood> = useSelector(
    (state: RootStateOrAny) => state.moods.moods
  )

  const curatorSpotifyId = useSelector(getCuratorSpotifyId)

  const [modal, setModalValue] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [modalLoading, setModalLoading] = useState(false)
  const [playList, setPlaylistValue] = useState<NewPlaylist>({
    id: null,
    genres: [],
    selectedGenres: [],
    selectedLanguages: [],
    selectedMoods: [],
    relevantGenres: [],
    playListInfo: {},
  })
  const [isModalSpotify, setModalSpotify] = useState(false)
  const [activeTab, setActiveTab] = useState(1)
  const [activePlaylists, setActivePlaylists] = useState<PlaylistsProps[]>([])
  const [inactivePlaylists, setInactivePlaylists] = useState<PlaylistsProps[]>(
    []
  )
  const [pendingPlaylists, setPendingPlaylists] = useState<PlaylistsProps[]>([])
  const [inappropriatePlaylists, setInappropriatePlaylists] = useState<
    PlaylistsProps[]
  >([])
  const [emptyGenresPlaylists, setEmptyGenresPlaylists] = useState<
    PlaylistsProps[]
  >([])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const socketRef = useRef<any>()

  const getGenres = (arr: Array<Genre> | Array<TrackGenre>) =>
    arr.map(el => ({
      id: el.genre_id,
      genre_name: el.Genre?.genre_name,
    }))

  const getLanguages = (arr: Array<Language>) =>
    arr.map(el => ({
      id: el.language_id,
      language_name: el.Language?.language_name,
    }))

  const getMoods = (arr: Array<Mood>) =>
    arr.map(el => ({
      id: el.mood_id,
      mood_name: el.Mood.mood_name,
    }))

  const handleGenresEdit = (
    id: number | string,
    settingUpNewPlaylist: boolean
  ) => {
    const selectedPlayList = playlists.find(item => item.id === id)
    const index = selectedPlayList?.playlist_url.indexOf('playlists')

    const playlistsID = selectedPlayList?.playlist_url
      // @ts-ignore
      .substring(index)
      .slice(10)
      .substring(0, 22)

    const callback = (
      error: string,
      payload: { autoselectedGenres: Array<{ id: number; genreName: string }> }
    ) => {
      setModalLoading(false)
      const playlistNewValue = {
        id: selectedPlayList?.id,
        genres: allGenres,
        selectedGenres:
          selectedPlayList?.PlaylistGenres &&
          getGenres(selectedPlayList?.PlaylistGenres),
        selectedLanguages:
          selectedPlayList?.PlaylistLanguages &&
          // @ts-ignore
          getLanguages(selectedPlayList?.PlaylistLanguages),
        selectedMoods:
          selectedPlayList?.PlaylistMoods &&
          getMoods(selectedPlayList?.PlaylistMoods),
        relevantGenres:
          payload &&
          payload.autoselectedGenres
            .map((el: { id: number; genreName: string }) => ({
              id: el.id,
              genre_name: el.genreName,
            }))
            .slice(0, 15),
        playListInfo: {
          name: selectedPlayList?.playlist_name,
          img: selectedPlayList?.playlist_cover,
        },
      }
      if (
        !error &&
        payload &&
        payload.autoselectedGenres.length > 0 &&
        isEmpty(selectedPlayList?.PlaylistGenres) &&
        isEmpty(selectedPlayList?.PlaylistLanguages)
      ) {
        // @ts-ignore
        setPlaylistValue(playlistNewValue)
      } else {
        if (selectedPlayList?.genres) {
          // @ts-ignore
          selectedPlayList.genres = getGenres(selectedPlayList?.PlaylistGenres)
        }

        if (selectedPlayList?.languages) {
          // @ts-ignore
          selectedPlayList.languages = getLanguages(
            // @ts-ignore
            selectedPlayList?.PlaylistLanguages
          )
        }

        // @ts-ignore
        setPlaylistValue(playlistNewValue)
      }
    }

    // @ts-ignore
    getAutoselectedSpotifyPlaylistGenres(playlistsID, callback)
    setModalLoading(true)
    setModalValue(true)
    if (window.innerWidth < 576) {
      setPageTitle(false)
    }
    settingUpNewPlaylist && setRecentlyAddedPlaylist(null)
  }

  useEffect(() => {
    if (recentlyAddedPlaylist) {
      if (
        playlists[playlists.length - 1].playlist_url === recentlyAddedPlaylist
      ) {
        handleGenresEdit(playlists[playlists.length - 1].id, true)
      }
    }
  }, [recentlyAddedPlaylist, playlists])

  useEffect(() => {
    const toActivePlaylists: Array<Playlist> = []
    const toInactivePlaylists: Array<Playlist> = []
    const toInappropriatePlaylists: Array<Playlist> = []
    const toEmptyGenresPlaylists: Array<Playlist> = []
    const toPendingPlaylists: Array<Playlist> = []

    playlists.forEach(item => {
      const { meets_conditions, status, PlaylistGenres } = item
      if (meets_conditions && status === 'activated' && PlaylistGenres.length) {
        toActivePlaylists.push(item)
      }
      if (status === 'deactivated' || status === 'pending') {
        toInactivePlaylists.push(item)
      }
      if (!meets_conditions) {
        toInappropriatePlaylists.push(item)
      }
      if (meets_conditions && !PlaylistGenres.length) {
        toEmptyGenresPlaylists.push(item)
      }
      if (meets_conditions && status === 'on_review' && PlaylistGenres.length) {
        toPendingPlaylists.push(item)
      }
    })

    // @ts-ignore
    setActivePlaylists(toActivePlaylists)
    // @ts-ignore
    setInactivePlaylists(toInactivePlaylists)
    // @ts-ignore
    setInappropriatePlaylists(toInappropriatePlaylists)
    // @ts-ignore
    setEmptyGenresPlaylists(toEmptyGenresPlaylists)
    // @ts-ignore
    setPendingPlaylists(toPendingPlaylists)
  }, [playlists])

  const removeDuplicatedPlaylists = (array: PlaylistsProps[]) =>
    Array.from(
      new Set(
        array.map(el => el.id).map(id => array.find(item => item.id === id))
      )
    )

  useEffect(() => {
    if (!socketRef.current && APP.SOCKET_URL) {
      socketRef.current = io(APP.SOCKET_URL, { path: '/my-custom-path/' })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    socketRef.current?.on('newPlaylists', (data: any) => {
      if (data) {
        if (data.Playlists && data.Playlists.length) {
          updateStatePlaylists(data)
          getCuratorRank()
        } else if (
          data.statusCode === 400 &&
          data.error.error.error_description === 'Invalid refresh token'
        ) {
          setModalSpotify(true)
        }

        setIsLoading(false)
      }
    })

    return () => {
      socketRef.current?.disconnect()
    }
  }, [])

  useEffect(() => {
    dispatch(getAllCuratorGenres())
    dispatch(getAllLanguages())
    dispatch(getAllMoods())
  }, [])

  const handleInformationSave = (
    playlist_id: number,
    genres: Array<Genre>,
    playlist_languages: Array<Language>,
    moods: Array<Mood>,
    callback: (error: ErrorWithFlag) => void
  ) => {
    changePlaylistInformation(
      playlist_id,
      // @ts-ignore
      genres.map(({ id }) => id),
      playlist_languages.map(({ id }) => id),
      moods,
      error => {
        if (!error) {
          getCuratorRank()
          getPlaylists()
        }
        callback(error)
      }
    )
  }

  const checkAccessToken = () => {
    if (spotifyAccessToken && curatorSpotifyId) {
      setIsLoading(true)
      socketRef.current?.emit('playlists', { spotify_id: curatorSpotifyId })
    }
  }

  const toggle = () => setModalSpotify(!isModalSpotify)

  const renderPlaylists = useCallback(() => {
    const sortedInactivePlaylists = [
      ...emptyGenresPlaylists,
      ...inactivePlaylists,
      ...inappropriatePlaylists,
    ]
    const sortedPlaylists = [
      ...activePlaylists,
      ...emptyGenresPlaylists,
      ...pendingPlaylists,
      ...inactivePlaylists,
      ...inappropriatePlaylists,
    ]
    let playlistToRender = removeDuplicatedPlaylists(sortedPlaylists)
    switch (activeTab) {
      case 1:
        playlistToRender = removeDuplicatedPlaylists(sortedPlaylists)
        break
      case 2:
        playlistToRender = pendingPlaylists
        break
      case 3:
        playlistToRender = activePlaylists
        break
      case 4:
        playlistToRender = removeDuplicatedPlaylists(sortedInactivePlaylists)
        break
      default:
        break
    }

    return playlistToRender.map(
      item =>
        item && (
          <PlayListCard
            followers={item.followers}
            genres={getGenres(item.PlaylistGenres)}
            key={item.id}
            playListName={item.playlist_name}
            status={item.status}
            monthlyListeners={item.monthly_listeners}
            playlistID={item.id}
            meetConditions={item.meets_conditions}
            selectedGenres={item.PlaylistGenres}
            // @ts-ignore
            selectedLanguages={item.PlaylistLanguages}
            playlistCover={item.playlist_cover}
            score={item.score}
            stats={item.ArtistStats}
            extraScore={item.extra_score}
            level={item.level}
            languages={languages}
            onGenresEdit={handleGenresEdit}
          />
        )
    )
  }, [
    activeTab,
    activePlaylists,
    inactivePlaylists,
    pendingPlaylists,
    inappropriatePlaylists,
    emptyGenresPlaylists,
  ])

  return (
    <>
      <S.Card>
        {window.innerWidth > 576 ? (
          <S.CardBody>
            <S.ButtonsContainer>
              <AddPlaylistModal
                getCuratorRank={getCuratorRank}
                setIsLoading={setIsLoading}
                isLoading={isLoading}
                setRecentlyAddedPlaylist={setRecentlyAddedPlaylist}
                onCheckPlaylist={checkPlaylist}
              />
              <WhiteGreyBtn
                color="whiteGrey"
                // @ts-ignore
                disabled={isLoading}
                onClick={checkAccessToken}
              >
                {isLoading ? (
                  <ReactLoading
                    className="loading"
                    color={colors.greyTextWhiteBg}
                    height={24}
                    type="spinningBubbles"
                  />
                ) : (
                  <>
                    <S.IconContainer>
                      <CachedIcon size="16" />
                    </S.IconContainer>
                    {t('playlistsPage.refreshData')}
                  </>
                )}
              </WhiteGreyBtn>
            </S.ButtonsContainer>
            <S.TabTriggersContainer>
              <S.TabTrigger
                active={activeTab === 1}
                onClick={() => setActiveTab(1)}
              >
                All
                <span>{playlists.length}</span>
              </S.TabTrigger>
              <S.TabTrigger
                active={activeTab === 2}
                onClick={() => setActiveTab(2)}
              >
                On review
                <span>{pendingPlaylists.length}</span>
              </S.TabTrigger>
              <S.TabTrigger
                active={activeTab === 3}
                onClick={() => setActiveTab(3)}
              >
                Active
                <span>{activePlaylists.length}</span>
              </S.TabTrigger>
              <S.TabTrigger
                active={activeTab === 4}
                onClick={() => setActiveTab(4)}
              >
                Inactive
                <span>
                  {
                    removeDuplicatedPlaylists([
                      ...inactivePlaylists,
                      ...inappropriatePlaylists,
                      ...emptyGenresPlaylists,
                    ]).length
                  }
                </span>
              </S.TabTrigger>
            </S.TabTriggersContainer>
            <S.Table>{renderPlaylists()}</S.Table>
          </S.CardBody>
        ) : (
          !modal && (
            <>
              <S.TabTriggersOverflow>
                <S.TabTriggersContainer>
                  <S.TabTrigger
                    active={activeTab === 1}
                    onClick={() => setActiveTab(1)}
                  >
                    All
                    <span>{playlists.length}</span>
                  </S.TabTrigger>
                  <S.TabTrigger
                    active={activeTab === 2}
                    onClick={() => setActiveTab(2)}
                  >
                    On review
                    <span>{pendingPlaylists.length}</span>
                  </S.TabTrigger>
                  <S.TabTrigger
                    active={activeTab === 3}
                    onClick={() => setActiveTab(3)}
                  >
                    Active
                    <span>{activePlaylists.length}</span>
                  </S.TabTrigger>
                  <S.TabTrigger
                    active={activeTab === 4}
                    onClick={() => setActiveTab(4)}
                  >
                    Inactive
                    <span>
                      {
                        removeDuplicatedPlaylists([
                          ...inactivePlaylists,
                          ...inappropriatePlaylists,
                          ...emptyGenresPlaylists,
                        ]).length
                      }
                    </span>
                  </S.TabTrigger>
                </S.TabTriggersContainer>
              </S.TabTriggersOverflow>
              <S.ButtonsContainer>
                <FindPlaylistMobile
                  getCuratorRank={getCuratorRank}
                  setIsLoading={setIsLoading}
                  isLoading={isLoading}
                  setRecentlyAddedPlaylist={setRecentlyAddedPlaylist}
                  onCheckPlaylist={checkPlaylist}
                />
                <S.RefreshBtnMobile
                  disabled={isLoading}
                  onClick={checkAccessToken}
                >
                  {isLoading ? (
                    <ReactLoading
                      className="loading"
                      height={24}
                      type="spinningBubbles"
                    />
                  ) : (
                    <CachedIcon size="16" />
                  )}
                </S.RefreshBtnMobile>
              </S.ButtonsContainer>
              {renderPlaylists()}
            </>
          )
        )}
      </S.Card>

      <PlaylistEditModal
        // @ts-ignore
        handleSave={handleInformationSave}
        isOpen={modal}
        isPlaylist
        item={playList}
        loading={modalLoading}
        toggle={setModalValue}
        setPageTitle={setPageTitle}
        languages={languages}
        userEmail={userEmail}
        allMoods={allMoods}
        settingNewPlaylist={!!recentlyAddedPlaylist}
      />
      <ConnectToSpotifyModal {...{ modal: isModalSpotify, toggle }} />
    </>
  )
}

export default PlayList
